// extracted by mini-css-extract-plugin
module.exports = {"logo":"overlay__logo--2xKKA"};
    if(module.hot) {
      // 1542402590461
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  